import { ProductTabMain } from './main/product-tab-main';
import { ProductTabProperties } from './properties';
import { ProductTabReviews } from './reviews';
import {
  ProductTabStatistics,
  ProductTabStatisticsLegacyNewUi,
} from './statistics';
import { ProductTabStatisticsLegacy } from './statistics-legacy';

export {
  ProductTabMain,
  ProductTabProperties,
  ProductTabReviews,
  ProductTabStatistics,
  ProductTabStatisticsLegacyNewUi,
  ProductTabStatisticsLegacy,
};
